import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PillCheckbox from 'Components/profile/PillCheckbox';
import IconSvg from '../IconSvg';

const InterestsSelector = ({
  interests,
  interestsArray,
  onChange,
  selections,
  strings,
}) => {
  const expandBy = 10;
  const mobileLimit = 10;
  const desktopLimit = 20;
  const [initialLimit, setInitialLimit] = useState(mobileLimit);
  const [limit, setLimit] = useState(mobileLimit);
  const enableTruncation = interestsArray.length >= initialLimit;
  const truncated = interestsArray.length > limit ? true : false;
  const truncatedLength =
    interestsArray.length - limit >= expandBy
      ? expandBy
      : interestsArray.length - limit;

  const handleClick = () => {
    if (truncated) {
      const newLimit = limit + expandBy;
      setLimit(newLimit);
    } else {
      setLimit(initialLimit);
    }
  };

  const initializeTruncation = () => {
    if (window.innerWidth >= 1024) {
      setInitialLimit(desktopLimit);
      setLimit(desktopLimit);
    }
  };

  useEffect(() => {
    initializeTruncation();
  }, []);

  return (
    <div>
      {interestsArray.slice(0, limit).map((interest) => (
        <PillCheckbox
          checked={selections.includes(interest)}
          image={`https://account.redbull.com/bundles/assets/static/img/${interest}.jpg`}
          key={interest}
          onChange={onChange}
          text={interests[interest].name}
          value={interest}
        />
      ))}
      {enableTruncation && (
        <label
          className={`button--pill checkbox--pill ${truncated ? '' : 'isOpen'}`}
          onClick={handleClick}
        >
          <div className="checkbox__indicator">
            <span className="checkbox__text">
              {truncated
                ? strings.more.formatUimTranslation(truncatedLength)
                : strings.showLess}
            </span>
            <span className="select__icon">
              <IconSvg type="arrowDown" />
            </span>
          </div>
        </label>
      )}
    </div>
  );
};

InterestsSelector.propTypes = {
  interests: PropTypes.object.isRequired,
  interestsArray: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selections: PropTypes.array.isRequired,
  strings: PropTypes.object.isRequired,
};

export default InterestsSelector;
